<template>
  <div class="jchg">
    <headerBanner :bannerUrl='bannerUrl'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i8"></i></div><p>精彩回顾</p>
    </div>
    <div class="jchg_list">
      <div class="title">
        <span class="EY_Regular">{{title}}</span>
      </div>
      <iframe  :src="data"></iframe>
    </div>
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'zxxy',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      title:'',
      bannerUrl:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
    

     this.$http.get('https://eympe.vapps.me/index.php?g=Index&m=Index&a=picture&id='+this.$route.params.id,
       {
          
        },
       /*{emulateJSON : true}*/)
   .then((response) => {
         this.data=response.body.data.jumpurl
         this.title = response.body.data.title
         this.bannerUrl = this.domain+response.body.bgpic
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  i.i8{
    width: 0.36rem;
    height: 0.4rem;
    background-position: -2.18rem -1.28rem;
  }
  .jchg_list{
    padding: 0 0.34rem;
  }
 .jchg_list .title{
    font-size: 0.25rem;
    color: #000;
    margin-bottom: 0.2rem;
  }
  .jchg_list iframe{
    border:0.06rem solid #d1d4d8;
    width: 100%;
    height: 3rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/jchg_video.vue